module.exports = __webpack_public_path__ + "static/foxquilt-screen1-fa4df8f6d9474da71e203f918d6cd26c.jpg";